// Kept free of `import.meta.env` so the browser tests can import it in Node.
const permanentFeatureToggleKeys = ["maintenanceMode", "maintenanceModeCcf", "maintenanceModePcf"] as const;

export const featureToggleKeys = [
  ...permanentFeatureToggleKeys,
  "inboundLogisticsAddressMatching",
  "logisticsMassUploadLimitOnNumberOfRowsUpload",
  "massUploadScenarioSelector",
  "isUsingTargetColumnsDataImporterMappingViewMode",
  "econautDemo",
  "materialsMassUpload",
  "materialsBulkEdit",
  "pcfReportExtraction",
  "reductionMvp",
  "pcfReportUploaderInEfLibrary",
  "reductionPcfTab",
  "enableReductionPlanReport",
  "ccfEmissionSourceTasks",
  "efLibraryFormSizeSwitcher",
] as const;

export type FeatureToggleKey = (typeof featureToggleKeys)[number];

export type FeatureToggles = Record<FeatureToggleKey, boolean>;

export const initialFeatureToggles = featureToggleKeys.reduce<FeatureToggles>((acc, key) => {
  acc[key] = false;
  return acc;
}, {} as FeatureToggles);
